import { Routes, Route, Link, Navigate } from 'react-router-dom';
import { Join } from './pages/Join';
import { Play } from './pages/Play';
import { AdminLogin } from './pages/AdminLogin';
import { AdminGames } from './pages/AdminGames';
import { AdminConsole } from './pages/AdminConsole';
import { Authoring } from './pages/Authoring';
import { Leaderboard } from './pages/Leaderboard';
import { History } from './pages/History';

export function App() {
  return (
    <div className="app">
      <header className="topbar">
        <Link to="/" className="brand">🍺 Beernerd</Link>
        <nav>
          <Link to="/leaderboard">Leaderboard</Link>
          <Link to="/admin">Admin</Link>
        </nav>
      </header>
      <main className="content">
        <Routes>
          <Route path="/" element={<Join />} />
          <Route path="/play/:code" element={<Play />} />
          <Route path="/play" element={<Navigate to="/" replace />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/games" element={<AdminGames />} />
          <Route path="/admin/console/:gameId" element={<AdminConsole />} />
          <Route path="/admin/authoring" element={<Authoring />} />
          <Route path="/leaderboard" element={<Leaderboard />} />
          <Route path="/history" element={<History />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
    </div>
  );
}
